import { Component, OnInit, Renderer2, ElementRef, NgZone, Injector, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { ComboListComponent } from '@farris/ui-combo-list';
import { ComboListDefaultOptions } from '../../model/editor-default-options';
import { ValueChangeParams } from '../../model/editor.type';
import { PreviewBaseEditorDirective } from './base-editor.directive';

@Component({
    selector: 'preview-editor-combolist',
    template: `
        <div [formGroup]="group" class="f-datagrid-cell-formgroup farris-group-auto">
            <farris-combo-list #cmblist style="width: 100%"
                [formControlName]="column.field"
                [readonly]= "options.readonly"
                [editable]= "options.editable"
                [(selectedValues)]="options.selectedValues"
                [idField]="options.idField"
                [textField]="options.textField"
                [multiSelect]="options.multiSelect"
                [valueField]="options.valueField"
                [uri]="options.uri"
                [data]="options.data"
                [nosearch]="options.nosearch"
                [maxLength]="options?.maxLength"
                [context]="options?.context"
                [itemTemplate]="options?.itemTemplate"
                [enableClear]="options.enableClear"
                [autoWidth]="options.autoWidth"
                [panelHeight]="options.panelHeight"
                [panelWidth]="options.panelWidth"
                [enableCancelSelected]="options.enableCancelSelected"
                [beforeShow]="options?.beforeShow"
                [beforeHide]="options?.beforeHide"
                (showPanel)="onShowPanel($event)"
                (hidePanel)="onHidePanel($event)"
                (clear)="onClear($event)"
                (valueChange)="onValueChange($event)"
                (selectChange)="onSelectChange($event)"
                [showPanelType]="options?.showPanelEvent || 'click'"
                [mappingField]="options?.mappingField"
                [disabledField]="options?.disabledField"
                [showDisabledItem]="options?.showDisabledItem"
            ></farris-combo-list>
        </div>
    `
})
export class PreviewComboListComponent extends PreviewBaseEditorDirective implements OnInit, AfterViewInit, OnDestroy {
    stopPropagation = false;
    @ViewChild('cmblist') instance: ComboListComponent;

    constructor( render: Renderer2, el: ElementRef, private ngzone: NgZone, public injector: Injector) {
        super(render, el, injector);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.options = Object.assign( {} , ComboListDefaultOptions, this.options);
        if (this.options.showClear !== undefined) {
            this.options.enableClear = this.options.showClear;
        }

        if (this.formControl && this.formControl.value) {
            this.options.selectedValues = this.formControl.value;
        }
    }

    ngAfterViewInit() {
        this.inputElement = this.instance.input.textbox.nativeElement;
        super.ngAfterViewInit();
        // setTimeout(() => {
        //     this.instance.show();
        // });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.inputElement = null;
    }

    // onBeforeShow = () => {
    //     if (this.options.beforeShow) {
    //         return this.options.beforeShow(this);
    //     }
    //     return of(true);
    // }

    // onBeforeHide = () => {
    //     if (this.options.beforeHide) {
    //         return this.options.beforeHide(this);
    //     }
    //     return of(true);
    // }


    onShowPanel($event) {
        if (this.options.showPanel) {
            this.options.showPanel(this.eventPrams($event));
        } else if (this.options.onShown) {
            this.options.onShown(this.eventPrams($event));
        }
    }

    onHidePanel($event) {
        if (this.options.hidePanel) {
            this.options.hidePanel(this.eventPrams($event));
        } else if (this.options.onHidden) {
            this.options.onHidden(this.eventPrams($event));
        }
    }

    onClear($event) {
        if (this.options.clear) {
            this.options.clear(this.eventPrams($event));
        }
    }

    onValueChange($event) {
        if (this.options.valueChange) {
            this.options.valueChange(this.eventPrams($event));
        }
    }

    onSelectChange($event) {
        if (this.options.selectChange) {
            this.options.selectChange(this.eventPrams($event));
        }
    }

    hide() {
        this.instance.hide();
    }

    private eventPrams($event): ValueChangeParams {
        const p = this.eventParams($event);
        p['instance'] = this.instance;
        p['editor'] = this;
        return p;
    }
}
